import React, { useContext } from 'react'
import { AuthContext } from '../../contexts/AuthContext';
import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
    const auth = useContext(AuthContext);
    return !auth.isAdmin() ? <Navigate to="/" /> : children;
}

export default AdminRoute;